import React, { useEffect, useState } from "react";
import CookieConsentDrawer from "./CookieConsentDrawer";
import "./CookieConsent.scss";

const CookieConsent: React.FC = () => {
  const [showSmall, setShowSmall] = useState(false);
  const [openDrawer, setOpenDrawer] = useState(false);

  useEffect(() => {
    const stored = localStorage.getItem("cookiePreferences");
    if (!stored) {
      setShowSmall(true);
    }
  }, []);

  const handleAcceptAll = () => {
    localStorage.setItem(
      "cookiePreferences",
      JSON.stringify({
        version: "v1",
        prefs: {
          necessary: true,
          session: true,
          persistent: true,
          performance: true,
          functional: true,
          marketing: true,
          unclassified: true,
        },
      })
    );
    setShowSmall(false);
  };

  const handleManagePreferences = () => {
    setShowSmall(false); // 🔥 hide small version
    setOpenDrawer(true);
  };

  return (
    <div className="cookie-consent">
      {/* Small version */}
      {openDrawer && (
        <img
          src="https://public.ticca.com/images/svg/Cookie.svg"
          alt="cookie"
          className="cookie-img"
        />
      )}
      {showSmall && !openDrawer && (
        <div className="cookie-small-card">
          <button
            className="close-btn"
            onClick={() => {
              setShowSmall(false);
            }}
          >
            ×
          </button>
          <div className="cookie-content">
            <h4>Your privacy matters to us</h4>
            <div className="cookie-dev">
              {" "}
              <img
                src="https://public.ticca.com/images/svg/Cookie.svg"
                alt="cookie"
                className="cookie-icon"
              />
              <p>   We collect your data in order to improve your experience in the
                form of cookies.
             
              </p>
            </div>

            <div className="cookie-small-actions">
              <button className="accept-btn" onClick={handleAcceptAll}>
                Accept All
              </button>
              <button
                className="necessary-btn"
                onClick={handleManagePreferences}
              >
                Necessary Only
              </button>
              <button
                className="customize-btn"
                onClick={handleManagePreferences}
              >
                Customize
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Full drawer */}
      {openDrawer && (
        <div className="cookie-modal">
          <CookieConsentDrawer
            onClose={() => {
              setOpenDrawer(false);
              setShowSmall(true); // 👈 show small version again if needed
            }}
            onSave={() => setOpenDrawer(false)}
          />
        </div>
      )}
    </div>
  );
};

export default CookieConsent;
